const initialState = {
  requestingConsultaCaratula: false,
  consultaCaratula: null,
  requestingConsultaCoem: false,
  consultaCoem: null,
  openAdd: false,
  openAddCoem: false,
  openAddCaratula: false,
  giros: [],
  buques: [],
  selectedGiro: null,
  selectedExportador: null,
  requestingGiros: null,
  status: false,
  codigoAduana: null,
  mensajeAduana: null,
  idAduana: null,
  showAlert: false,
  isRequestingSoap: false,
  totalInactivas: null,
  totalActivas: null,
  totalFinalizadas: null,
  cierreCumplido: true,
  pesoTotalEmbarcado: null,
  historialCaratula: null,
  historialCoem: null,
  buqueAceitero: false,
  exportadoresSeleccionados: [],
  caratulaExportador: [],
  exportadores: [],
  caratulasConEstado: [],
  filtroExportador: null,
  filtroExportadorRazonSocial: null,
  estadoTablas: 2 // 1: Inactivas, 2: Activas, 3: Finalizadas 
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'REQUEST_CONSULTA_CARATULA':
      return {
        ...state,
        requestingConsultaCaratula: true,
        consultaCaratula: null
      }
    case 'RECEIVE_CONSULTA_CARATULA':
      return {
        ...state,
        requestingConsultaCaratula: false,
        consultaCaratula: action.consultaCaratula
      }
    case 'REQUEST_ACTUALIZAR_GIRO':
      return {
        ...state,
        selectedGiro: action.giro
      }
    case 'REQUEST_ACTUALIZAR_EXPORTADOR':
      return {
        ...state,
        selectedExportador: action.exportador
      }
    case 'REQUEST_CONSULTA_COEMS':
      return {
        ...state,
        requestingConsultaCoem: true,
        consultaCoem: null
      }
    case 'RECEIVE_CONSULTA_COEMS':
      return {
        ...state,
        requestingConsultaCoem: false,
        consultaCoem: action.consultaCoem
      }
    case 'RESET_CONSULTA_COEM':
      return {
        ...state,
        consultaCoem: null
      }
    case 'RECEIVE_MOSTRAR_DIALOG_ADD_COEM':
      return {
        ...state,
        openAddCoem: action.estado
      }
    case 'RECEIVE_MOSTRAR_DIALOG_ADD_CARATULA':
      return {
        ...state,
        openAddCaratula: action.estado
      }
    case 'UPDATE_STATUS_MODAL':
      return {
        ...state,
        status: action.status
      }
    case 'UPDATE_ESTADO_REGISTRO':
      return {
        ...state,
        codigoAduana: action.codigoAduana,
        mensajeAduana: (Array.isArray(action.mensajeAduana) ? action.mensajeAduana.join(', ') : action.mensajeAduana),
        idAduana: action.idAduana
      }
    case 'RESET_ESTADO_REGISTRO':
      return {
        ...state,
        codigoAduana: null,
        mensajeAduana: null,
        idAduana: null
      }
    case 'REQUEST_GIROS':
      return {
        ...state,
        requestingGiros: true,
        giros: null
      }
    case 'RECEIVE_GIROS':
      return {
        ...state,
        requestingGiros: false,
        giros: action.giros
      }
    case 'REQUEST_BUQUES':
      return {
        ...state,
        requestingBuques: true,
        buques: null
      }
    case 'RECEIVE_BUQUES':
      return {
        ...state,
        requestingBuques: false,
        buques: action.buques
      }
    case 'SET_REQUESTING_SOAP':
      return {
        ...state,
        isRequestingSoap: true
      }
    case 'RESET_REQUESTING_SOAP':
      return {
        ...state,
        isRequestingSoap: false
      }
    case 'UPDATE_SHOW_ALERT':
      return {
        ...state,
        showAlert: action.showAlert
      }
    case 'UPDATE_TOTAL_INACTIVAS':
      return {
        ...state,
        totalInactivas: action.totalInactivas
      }
    case 'UPDATE_TOTAL_ACTIVAS':
      return {
        ...state,
        totalActivas: action.totalActivas
      }
    case 'UPDATE_TOTAL_FINALIZADAS':
      return {
        ...state,
        totalFinalizadas: action.totalFinalizadas
      }
    case 'UPDATE_CIERRE_CUMPLIDO':
      return {
        ...state,
        cierreCumplido: action.newValue
      }
    case 'CONSULTA_PESO_TOTALES_EMBARCADOS':
      return {
        ...state,
        pesoTotalEmbarcado: action.pesoTotalEmbarcado
      }
    case 'RECEIVE_HISTORIAL_CARATULA':
      return {
        ...state,
        historialCaratula: action.response
      }
    case 'RESET_HISTORIAL_CARATULA':
      return {
        ...state,
        historialCaratula: null
      }
    case 'RECEIVE_HISTORIAL_COEM':
      return {
        ...state,
        historialCoem: action.response
      }
    case 'RESET_HISTORIAL_COEM':
      return {
        ...state,
        historialCoem: null
      }
    case 'RECEIVE_CARATULA_EXPORTADOR':
      return {
        ...state,
        caratulaExportador: [...state.caratulaExportador, action.exportador]
      }
    case 'ELIMINAR_CARATULA_EXPORTADOR':
      return {
        ...state,
        caratulaExportador: [...state.caratulaExportador].filter((exp) => exp != action.exportador)
      }
    case 'RESET_CARATULA_EXPORTADOR':
      return {
        ...state,
        caratulaExportador: []
      }
    case 'UPDATE_LISTA_EXPORTADORES_SELECCIONADOS':
      return {
        ...state,
        exportadoresSeleccionados: action.exportador
      }
    case 'ACTUALIZAR_EXPORTADORES':
      return {
        ...state,
        exportadores: action.exportadores
      }
    case 'ACTUALIZAR_CARATULAS_CON_ESTADO':
      return {
        ...state,
        caratulasConEstado: action.caratulasConEstado
      }
    case 'RESET_CARATULAS_CON_ESTADO':
      return {
        ...state,
        caratulasConEstado: []
      }
    case 'CHANGE_ESTADO_BUQUE_ACEITERO':
      return {
        ...state,
        buqueAceitero: !state.buqueAceitero
      }
    case 'SET_ESTADO_BUQUE_ACEITERO':
      return {
        ...state,
        buqueAceitero: action.aceitero
      }
    case 'SET_ESTADO_TABLAS':
      return {
        ...state,
        estadoTablas: action.estadoTablas
      }
    case 'UPDATE_ESTADO_FILTRADO_EXPORTADORES':
      return {
        ...state,
        filtroExportador: action.exportador,
        filtroExportadorRazonSocial: action.razonSocial
      }
    case 'RESET_ESTADO_FILTRADO_EXPORTADORES':
      return {
        ...state,
        filtroExportador: null,
        filtroExportadorRazonSocial: null
      }
    default:
      return state
  }
}
